import routes from './routes'
import store from './store'

export default {
    name: 'm-packages',
    store: store,
    routes: routes
}